//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { ContentDrawerActions } from '@redux/content-drawer/contentDrawerActions';
import { CONTENT_DRAWER_ACTIONS, IContentDrawerState } from '@redux/content-drawer/contentDrawerModel';

const initialState: IContentDrawerState = {
  drawerSettings: {},
  pageDrawerSettings: {},
};

export default function ContentDrawerReducer(
  state: IContentDrawerState = initialState,
  action: ContentDrawerActions,
): IContentDrawerState {
  switch (action.type) {
    case CONTENT_DRAWER_ACTIONS.SET_DRAWER_SETTINGS: {
      return {
        ...state,
        drawerSettings: action.drawerSettings,
      };
    }
    case CONTENT_DRAWER_ACTIONS.SET_PAGE_DRAWER_SETTINGS: {
      return {
        ...state,
        pageDrawerSettings: action.pageDrawerSettings,
      };
    }
  }
  return state;
}
